export default `float s = 1.;
  p.z += time;
  float c = length(mod(p, 1.)-.5)-.4;
  for(int i = 0; i < 10; i++) {
    p*=1.2;
    s*=1.2;
    c = max(c, -(length(mod(p, 1.)-.5)-.4)/s);
  }
  return c;
}`